import { PulsesConstants } from './pulses.constants'
import { IPulsesAction, IPulsesState } from './pulses.types'

export const initialPulsesState: IPulsesState = {
  pulseCarotid: null,
  pulseRadL: null,
  pulseBraL: null,
  pulseFemL: null,
  pulseDorsL: null,
  pulseCarotidR: null,
  pulseRadR: null,
  pulseBraR: null,
  pulseFemR: null,
  pulseDorsR: null,
}

export function pulsesReducer(state: IPulsesState = initialPulsesState, action: IPulsesAction): IPulsesState {
  switch (action.type) {
    case PulsesConstants.SET_PULSECAROTID:
      return { ...state, pulseCarotid: action.pulseCarotid }
    case PulsesConstants.SET_PULSERADL:
      return { ...state, pulseRadL: action.pulseRadL }
    case PulsesConstants.SET_PULSEBRAL:
      return { ...state, pulseBraL: action.pulseBraL }
    case PulsesConstants.SET_PULSEFEML:
      return { ...state, pulseFemL: action.pulseFemL }
    case PulsesConstants.SET_PULSEDORSL:
      return { ...state, pulseDorsL: action.pulseDorsL }
    case PulsesConstants.SET_PULSECAROTIDR:
      return { ...state, pulseCarotidR: action.pulseCarotidR }
    case PulsesConstants.SET_PULSERADR:
      return { ...state, pulseRadR: action.pulseRadR }
    case PulsesConstants.SET_PULSEBRAR:
      return { ...state, pulseBraR: action.pulseBraR }
    case PulsesConstants.SET_PULSEFEMR:
      return { ...state, pulseFemR: action.pulseFemR }
    case PulsesConstants.SET_PULSEDORSR:
      return { ...state, pulseDorsR: action.pulseDorsR }

    case PulsesConstants.RESET_STATE:
      return { ...state, ...initialPulsesState }

    case PulsesConstants.SET_PULSES:
      return { ...state, ...action.pulses }
    default:
      return state
  }
}
